import { Image, Pill } from "@src/appV2/redesign/system/ui-components";

import yelpLogo from "./yelpLogo.png";

export function YelpReviewBadge() {
  return (
    <Pill
      size="small"
      variant="filled"
      label={<Image src={yelpLogo} alt="Yelp" height={14} />}
      backgroundColor={(theme) => theme.palette.text.tertiary}
      sx={{ width: "fit-content", "& > *:first-child": { display: "flex" } }}
    />
  );
}
